/* eslint-disable */
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import { Add } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { getCacheData } from "../../services/CacheService";
import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  id: null,
  idCrOrigen: null,
  descripcion: "",
};

const nameItemText = "Origen de Cristales";
//
// ########################################################################### 
//
const OrigenCristalDialog = ({
  onSave,
  onClose,
  setMessage,
  setShowMessage,
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [crOrigenes, setCrOrigenes] = useState([]);
  const [valueACCrOrigen, setValueACCrOrigen] = useState(null);
  const [inputvalueACCrOrigen, setInputvalueACCrOrigen] = useState("");
  //
  // ################################################################################
  //
  useEffect(() => {
    loadCrOrigenes();
  }, []);
  //
  // ################################################################################
  //
  const handleSave = () => {

    if (!valueACCrOrigen) {
      setMessage({
        severity: "error",
        messageText: "Debes seleccionar un Origen de Cristales",
      });
      setShowMessage(true);
      return;
    }

    save();
  };
  //
  // ########################################################################## 
  //
  const save = async () => {

    let _itemCrud = {
      id: valueACCrOrigen.id,
      descripcion_cr_origen: valueACCrOrigen.label,
    };

    const success = onSave(_itemCrud);
    if (success) {
      setItemCrudLocal(initialState);
      setValueACCrOrigen(null)
      setInputvalueACCrOrigen("");
    }
  };
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const loadCrOrigenes = async () => {
    const response = await getCacheData("cr_origen")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setCrOrigenes(_var);
    } else {
      setCrOrigenes([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    };
  }
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="sm"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              OrigenCristalDialog: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Autocomplete
                id="id-cr-origen"
                size="small"
                value={
                  valueACCrOrigen && valueACCrOrigen.id
                    ? valueACCrOrigen
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACCrOrigen(newValue);
                  setItemCrudLocal({
                    ...itemCrudLocal,
                    idCrOrigen: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputvalueACCrOrigen}
                onInputChange={(event, newInputValue) => {
                  setInputvalueACCrOrigen(newInputValue);
                }}
                options={crOrigenes}
                getOptionLabel={(option) => option.label || ""}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Origen de Cristal"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              // evita que abra/cierre el dropdown
                              e.stopPropagation();
                              loadCrOrigenes();
                            }}
                          >
                            <RefreshOutlinedIcon sx={{ fontSize: 18 }} />
                          </IconButton>
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
              >
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  size="small"
                  onClick={handleSave}
                  startIcon={<Add />}
                >
                  Agregar
                </Button>

                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCloseDialog}
                  startIcon={<CloseIcon />}
                >
                  Cerrar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog >

      <WaitingDialog open={isDoingSomething} />
    </>
  );
}; export default OrigenCristalDialog;
